import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { WorkloadClient, workloadApiRef } from './api/WorkloadApi';

export const workloadPlugin = createPlugin({
  id: 'workload',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: workloadApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new WorkloadClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** The workload inventory, mounted at /workloads. */
export const WorkloadPage = workloadPlugin.provide(
  createRoutableExtension({
    name: 'WorkloadPage',
    component: () => import('./components/WorkloadPage').then(m => m.WorkloadPage),
    mountPoint: rootRouteRef,
  }),
);
